import { Styles } from "@mcleod/core";

Styles.createClass("@keyframes rotation", "from { transform: rotate(0deg); }  to { transform: rotate(359deg); }", true);

export const ButtonStyles = Styles.make("btn", () => {
    return {
        base: {
            borderRadius: "4px",
            margin: "4px", fontSize: "0.75rem",
            outline: "none",
            border: "1px solid currentcolor",
            backgroundColor: "transparent",
            padding: "8px 19px",
            transition: Styles.HOVER_TRANSITION,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "inherit",
            color: "inherit"
        },
        focusEnabled: {
            "&:focus:enabled": Styles.HOVER_WITHOUT_BACKGROUND_COLOR,
        },
        hoverEnabled: {
            "&:hover:enabled": Styles.HOVER_WITHOUT_BACKGROUND_COLOR,
        },
        hoverWithBackgroundColor: {
            "&:hover:enabled": {
                boxShadow: "0 0 0 100vmax inset rgb(0 0 0/20%) !important"
            }
        },
        round: {
            borderRadius: "50%",
            border: "none",
            padding: "4px"
        },
        text: {
            border: "none"
        },
        withImage: { padding: "6px 19px" },
        "size-small": { width: "75px", height: "34px" },
        "size-medium": { width: "150px", height: "34px" },
        "size-large": { width: "200px", padding: "6px 19px", height: "34px", fontSize: "0.875rem" },
        "size-largest": { width: "250px", padding: "6px 19px", height: "34px", fontSize: "0.875rem" }
    }
});
